export const all_routes ={
    // home route
home: "/index",
      // -- auth --
      login:"/login",
      register:"/register",
      forgot_password:"/forgot-password",
      change_password:"/change-password",
      // -- product-app --
      product_app: "/appz",
      product_app_detail: "/app/:title_url",
      product_app_checkout: "/app/checkout",
      product_app_checkout_success: "/app/checkout-success",
      product_app_payment_success: "/app/payment-success",
      // -- pages --
      about:  "/about",
      gallery: "/portfolio",
      gallery_detail: "/portfolio/:title_url",
      faq:"/faq",
      blog_post: '/blogs',
      blog_post_detail:'/blog/:title_url',
      contact: '/contact',
      review:"/reviews",
      review_edit:"/review/edit",
      team: "/team",
      team_detail: "/team/:title_url",
      // -- admin-dashboard --
      dashboard_admin_app: '/dashboard/admin/app',
      dashboard_admin_app_detail: '/dashboard/admin/app/detail',
      dashboard_admin_cart: '/dashboard/admin/cart',
      dashboard_admin_cart_detail: '/dashboard/admin/cart/detail',
      dashboard_admin_favorite: '/dashboard/admin/favorite',
      dashboard_admin_home: '/dashboard/admin/home',
      dashboard_admin_order: '/dashboard/admin/order',
      dashboard_admin_order_detail: '/dashboard/admin/order/detail',
      dashboard_admin_review: '/dashboard/admin/review',
      dashboard_admin_stat: '/dashboard/admin/stat',
      dashboard_admin_user: '/dashboard/admin/user',
      dashboard_admin_user_detail: '/dashboard/admin/user/detail',
      dashboard_admin_user_edit: '/dashboard/admin/user/edit',
      //-- user-dashboard --
      dashboard_user_stat: '/dashboard/user/stat',
      dashboard_user_app: '/dashboard/user/app',
      dashboard_user_app_detail: '/dashboard/user/app/detail',
      dashboard_user_favorite: '/dashboard/user/favorite',
      dashboard_user_home: '/dashboard/user/home',
      dashboard_user_order: '/dashboard/user/order',
      dashboard_user_order_detail: '/dashboard/user/order/detail',
      dashboard_user_profile_detail: '/dashboard/user/profile/detail',
      dashboard_user_profile_edit: '/dashboard/user/profile/edit',
      dashboard_user_review: '/dashboard/user/review',
      dashboard_user_support: '/dashboard/user/support',
      //-- app-dashboard --
      dashboard_app_blog_post: '/dashboard/app/blog_post',
      dashboard_app_blog_post_edit: '/dashboard/app/blog_post/edit',
      dashboard_app_category: '/dashboard/app/category',
      dashboard_app_category_edit: '/dashboard/app/category/edit',
      dashboard_app_custom_field: '/dashboard/app/custom_field',
      dashboard_app_custom_field_edit: '/dashboard/app/custom_field/edit',
      dashboard_app_content: '/dashboard/app/content',
      dashboard_app_content_edit: '/dashboard/app/content/edit',
      dashboard_app_event: '/dashboard/app/event',
      dashboard_app_event_edit: '/dashboard/app/event/edit',
      dashboard_app_faq: '/dashboard/app/faq',
      dashboard_app_faq_edit: '/dashboard/app/faq/edit',
      dashboard_app_gallery: '/dashboard/app/gallery',
      dashboard_app_gallery_edit: '/dashboard/app/gallery/edit',
      dashboard_app_image_gallery: '/dashboard/image_gallery',
      dashboard_app_image_gallery_edit: '/dashboard/image_gallery',
      dashboard_app_group: '/dashboard/app/group',
      dashboard_app_group_edit: '/dashboard/app/group/edit',
      dashboard_app_home: '/dashboard/app/home',
      dashboard_app_item_field_value: '/dashboard/app/item/field_value',
      dashboard_app_item_field_value_edit: '/dashboard/app/item/field_value/edit',
      dashboard_app_sub_value_edit_pop_open: '/dashboard/sub_value/edit/pop_open',
      dashboard_app_user: '/dashboard/app/user',
      dashboard_app_user_edit: '/dashboard/app/user/edit',
      dashboard_app_order: '/dashboard/app/order',
      dashboard_app_order_detail: '/dashboard/app/order/detail',
      dashboard_app_order_edit: '/dashboard/app/order/edit',
      dashboard_app_page: '/dashboard/app/page',
      dashboard_app_page_edit: '/dashboard/app/page/edit',
      dashboard_app_product: '/dashboard/app/product',
      dashboard_app_product_edit: '/dashboard/app/product/edit',
      dashboard_app_review: '/dashboard/app/review',
      dashboard_app_service: '/dashboard/app/service',
      dashboard_app_service_edit: '/dashboard/app/service/edit',
      dashboard_app_team: '/dashboard/app/team',
      dashboard_app_team_edit: '/dashboard/app/team/edit',
      dashboard_app_template: '/dashboard/app/template',
      dashboard_app_template_edit: '/dashboard/app/template/edit',
      dashboard_app_type: '/dashboard/app/type',
      dashboard_app_type_edit: '/dashboard/app/type/edit',
};


